import { Validator, rules } from "@lchemy/model/validation";

export interface LoginCmd {
  email: string;
  password: string;
  recaptchaResponse: string;
}

export const loginCmdValidator: Validator<LoginCmd> = new Validator<LoginCmd>({
  email: [rules.required(), rules.isString(), rules.isEmail()],
  password: [rules.required(), rules.minLength(5)],
  recaptchaResponse: {
    nullable: true,
    check: (response) =>
      response == null || response.length === 0
        ? { reCaptchaResponseRequired: true }
        : null
  }
});
